export enum NovapostCodModeEnum {
    BACKWARD = 'backward',
    AFTERPAYMENT = 'afterpayment'
}
